// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"64b67ba3","277":"22f12143","822":"87881f8d"}[chunkId] + ".chunk.js";
};